/**
 * Calculates the chance of a special block spawning, based on the number of basic blocks, obstacles and remaining goal.
 * The chance is rounded to the nearest multiple of 5, and clamped between 10 and 40.
 * Returns 0 if there are no basic blocks or remaining goals.
 */
export function getSpecialSpawnChance(args: {
  numBasicBlocks: number;
  numObstacles: number;
  remainingGoal: number;
}) {
  if (!args.remainingGoal) return 0;
  if (!args.numBasicBlocks) return 0;

  // Calculate the raw chance
  const rawChance =
    (args.numBasicBlocks * args.remainingGoal) / Math.pow(args.numObstacles, 2);

  // Round the chance to multiple of 5
  const roundedChance = Math.ceil(rawChance / 5) * 5;

  // Clamp the chance between 10 and 40
  const clampedChance = Math.max(10, Math.min(40, roundedChance));

  // Return the chance as a percentage
  return clampedChance / 100;
}

/**
 * Calculates the chance of a powerup block spawning, based on the number of basic blocks and powerups.
 * The chance is rounded to the nearest multiple of 5, and clamped between 10 and 40.
 * Returns 0 if there are no basic blocks.
 */
export function getPowerupSpawnChance(args: {
  numBasicBlocks: number;
  numPowerups: number;
}) {
  if (!args.numBasicBlocks) return 0;

  // Calculate the raw chance
  const rawChance = args.numBasicBlocks / (args.numPowerups || 1);

  // Round the chance to multiple of 5
  const roundedChance = Math.ceil(rawChance / 5) * 5;

  // Clamp the chance between 10 and 40
  const clampedChance = Math.max(10, Math.min(40, roundedChance));

  // Return the chance as a percentage
  return clampedChance / 100;
}
